module.exports = __webpack_public_path__ + "static/img/10b.eb343fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/10b.jpg
// module id = dlEE
// module chunks = 1